import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const stats = [
    { label: 'Efektivita', value: '5ks/m²' },
    { label: 'Ekonomika (rozteč 20cm)', value: 'od 300Kč/m²' },
    { label: '9,6W varianta, rozteč 20cm', value: '6250lm/m²' },
    { label: 'Životnost', value: '50 000h' },
  ];

  return (
    <div className="relative pt-32 flex content-center items-center justify-center min-h-[120vh] bg-gray-900 overflow-hidden">
      <div className="absolute top-0 w-full h-full bg-cover bg-center opacity-50" style={{ backgroundImage: "url('https://www.lightwell.cz/media/produkty/realizace-oval-salon.webp')" }}></div>
      <div className="container relative mx-auto px-4 z-10">
        <div className="flex flex-wrap items-center">
          <div className="w-full lg:w-8/12 px-4">
            <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
              <h1 className="text-white font-bold text-6xl md:text-8xl leading-tight mb-8 italic tracking-tighter">LEDBAR <span className="text-blue-500">GRID</span><br />Revoluce v osvětlení</h1>
              <p className="text-2xl text-gray-300 mb-12 max-w-2xl leading-relaxed">Nová generace barových světel pro světelné boxy. Maximální efektivita, extrémní svítivost a instalace během několika minut.</p>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
                {stats.map((stat, idx) => (
                  <div key={idx} className="border-l-4 border-blue-600 pl-6">
                    <div className="text-3xl font-bold text-white">{stat.value}</div>
                    <div className="text-gray-400 text-[10px] uppercase tracking-widest mt-1 leading-tight">{stat.label}</div>
                  </div>
                ))}
              </div>
              <div className="flex flex-wrap gap-6">
                <a href="#vyhody" className="bg-blue-600 text-white px-12 py-5 rounded-full font-bold hover:bg-blue-700 transition-all shadow-2xl shadow-blue-600/40 text-lg uppercase tracking-wider">PROZKOUMAT VÝHODY</a>
                <a href="#instalace" className="bg-white/10 backdrop-blur-md text-white border border-white/20 hover:bg-white/20 px-12 py-5 rounded-full font-bold transition-all text-lg uppercase tracking-wider">JAK TO FUNGUJE?</a>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      <motion.div initial={{ opacity: 0, x: 50 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 1.2 }} className="hidden lg:block absolute right-[-5%] top-1/2 -translate-y-1/2 w-[45%]">
        <div className="relative"><img src="https://www.lightwell.cz/media/produkty/ledbar-trojice.webp" alt="LEDBAR Product" className="relative z-10 w-full h-auto rotate-3 hover:rotate-0 transition-transform duration-1000 ease-out" /></div>
      </motion.div>
    </div>
  );
};

export default Hero;